import {applyMiddleware, compose, legacy_createStore} from "redux";
import thunk from "redux-thunk";
import * as Utils from "../utils/index.js";
import _ from "lodash";
import reducer from "../reducers/index.js";
import {
    estaNaAreaAdministrativa,
    lerCredencialGuardada,
    registrarDispatchCredencial
} from "../features/credencialPublica.js";

/*
 * Credencial padrão do administrativo no desenvolvimento (npm run dev), para abrir
 * /administrativo sem vir do portal. Não entra no build de produção (import.meta.env.DEV).
 */
const CREDENCIAL_DESENVOLVIMENTO = 'yCWKyi66yD8ZRz%2ByhYacyqYyzBWUxYMFIsfUwD5fo%2BUhRDtYwfrneZZklYz86cuV2pGMfepURNVYHofyq6VbHjd48P7t8jEnh0PEfpk1pZRvF6OYSL4%2BDS2NbwsYrwOMe3%2BP%2BG0VuwmC6h%2BriJUfGdtKYwHRKI7brTz4Oir0zFRTGHLqNwNN6eX9e3PYXdMzBHiLI%2BBE2UpefZQ%2FXu0HCf75fv%2F02hxUheZS3hGNRmfnxsjwkB2%2FhxXoAk2cbyEn7khY0ib%2Fr9ZsnUFxVjdL2jXg6Hf1MC2YO36zXvq4Av13wRB7yy8VHeFi%2Fjlefoy2%2Fr8jJAcnrWtrMXTeQypDkA%3D%3D';

let preloadedState = {};

const queryStringParsed = Utils.queryStringParsed();

if (queryStringParsed) {
    if (queryStringParsed.embedded) {
        preloadedState = _.assign({}, preloadedState, {
            embedded: queryStringParsed.embedded === 'true'
        });
    }

    if (queryStringParsed.header) {
        preloadedState = _.assign({}, preloadedState, {
            showHeader: queryStringParsed.header === 'true'
        });
    }

    if (queryStringParsed.credencial) {
        preloadedState = _.assign({}, preloadedState, {
            credencial: queryStringParsed.credencial
        });
    }
}

// Área pública: a credencial da identificação continua valendo depois do F5 na mesma aba.
// No administrativo a credencial vem só da URL do portal.
if (!preloadedState.credencial && !estaNaAreaAdministrativa() && lerCredencialGuardada()) {
    preloadedState = _.assign({}, preloadedState, {
        credencial: lerCredencialGuardada()
    });
}

// Desenvolvimento: sem ?credencial= na URL, o administrativo usa a credencial padrão.
if (import.meta.env.DEV && !preloadedState.credencial && estaNaAreaAdministrativa()) {
    preloadedState = _.assign({}, preloadedState, {
        credencial: CREDENCIAL_DESENVOLVIMENTO
    });
}

const store = legacy_createStore(reducer, preloadedState, compose(applyMiddleware(thunk)));

registrarDispatchCredencial(store.dispatch);

export default store;